import './projects.scss';

import { Disclosure } from '@headlessui/react';
import AnimateHeight from 'react-animate-height';

const projects = [
  {
    title: 'Ferrari',
    number: '01',
  },
  {
    title: 'Brembo',
    number: '02',
    subtitle: 'brembo',
  },
  {
    title: 'Maserati',
    number: '03',
  },
  {
    title: 'Piaggio',
    number: '04',
  },
  {
    title: 'Stellantis',
    number: '05',
  },
];

const Projects: React.FC = () => {
  return (
    <section
      id="projects"
      className="projects grid grid-cols-12 gap-6 flex flex-col items-center bg-dark text-light px-6 py-6 min-h-screen"
    >
      <div className="col-span-12 lg:col-span-7 lg:col-start-5 projects-list">
        <p className='text text-light-70'>A few great names I’ve had the pleasure to work with include</p>
        {projects.map((project, index) => (
          <Disclosure key={index}>
            {({ open }) => (
              <div className="accordion">
                <Disclosure.Button className="project accordion-header flex justify-between w-full cursor-pointer">
                  <div className='title-wrapper'>
                    <span className="title">{project.title}</span>
                    {project?.subtitle === "brembo" &&(
                      <>
                        <div className='description-wrapper mobile'>
                          <div className='project-div'>
                            <p>
                              <span className="subtitle text-light-70">iF Design Award 2026 Winner</span>
                            </p>
                            <p>
                              <a className="subtitle text-light" target="_blank" href="https://ifdesign.com/en/winner-ranking/project/turning-energy-into-inspirationnew-brembo-website/768153">ifdesign.com</a>
                              <span className="subtitle text-light-70">, </span>
                              <a className="subtitle text-light" target="_blank" href="https://www.linkedin.com/posts/accenture-italia_ifdesignaward-accenturesong-design-activity-7455561025149435906-V8Jf?utm_source=share&utm_medium=member_ios&rcm=ACoAABRYw50BoFE3WFuXmEwU7MZZQxiSebrtKeg">Linkedin</a>
                              <span className="subtitle text-light-70">, </span>
                              <a className="subtitle text-light" target="_blank" href="https://www.instagram.com/p/DXwJvwyFsyF/?utm_source=ig_web_button_share_sheet">Instagram</a>
                            </p>
                          </div>
                          <div className='project-div'>
                            <p>
                              <span className="subtitle text-light-70">ADI Design Index 2025 Winner</span>
                            </p>
                            <p>
                              <a className="subtitle text-light" target="_blank" href="https://www.linkedin.com/posts/accenture-italia_design-pubblicaamministrazione-activity-7387388829659201537-9Js3?utm_source=share&utm_medium=member_desktop&rcm=ACoAAA0_sEUBQE9A14iVfgNzZa8a-v_XPo8P9iM">Linkedin</a>
                              <span className="subtitle text-light-70">, </span>
                              <a className="subtitle text-light" target="_blank" href="https://www.instagram.com/p/DQLzQYaDBTR/?img_index=1">Instagram</a>
                            </p>
                          </div>
                        </div>
                        <div className='description-wrapper desktop'>
                          <p>
                            <span className="subtitle text-light-70">iF Design Award 2026 Winner — </span>
                            <a className="subtitle text-light" target="_blank" href="https://ifdesign.com/en/winner-ranking/project/turning-energy-into-inspirationnew-brembo-website/768153">ifdesign.com</a>
                            <span className="subtitle text-light-70">, </span>
                            <a className="subtitle text-light" target="_blank" href="https://www.linkedin.com/posts/accenture-italia_ifdesignaward-accenturesong-design-activity-7455561025149435906-V8Jf?utm_source=share&utm_medium=member_ios&rcm=ACoAABRYw50BoFE3WFuXmEwU7MZZQxiSebrtKeg">Linkedin</a>
                            <span className="subtitle text-light-70">, </span>
                            <a className="subtitle text-light" target="_blank" href="https://www.instagram.com/p/DXwJvwyFsyF/?utm_source=ig_web_button_share_sheet">Instagram</a>
                          </p>
                          <p>
                            <span className="subtitle text-light-70">ADI Design Index 2025 Winner — </span>
                            <a className="subtitle text-light" target="_blank" href="https://www.linkedin.com/posts/accenture-italia_design-pubblicaamministrazione-activity-7387388829659201537-9Js3?utm_source=share&utm_medium=member_desktop&rcm=ACoAAA0_sEUBQE9A14iVfgNzZa8a-v_XPo8P9iM">Linkedin</a>
                            <span className="subtitle text-light-70">, </span>
                            <a className="subtitle text-light" target="_blank" href="https://www.instagram.com/p/DQLzQYaDBTR/?img_index=1">Instagram</a>
                          </p>
                        </div>
                      </>
                    )}
                    
                  </div>
                  <span className="number">{project.number}</span>
                </Disclosure.Button>
                {/*
                <AnimateHeight height={open ? 'auto' : 0} duration={300}>
                  <div className="accordion-body">
                    {project.images.map((img, i) => (
                      <img key={i} src={img} alt={`${project.title} ${i + 1}`} />
                    ))}
                  </div>
                </AnimateHeight>
                */}
              </div>
            )}
          </Disclosure>
        ))}
      </div>
    </section>
  );
};

export default Projects;
